var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85 6.15C9.85 8.19345 8.19345 9.85 6.15 9.85H3C2.44772 9.85 2 9.40228 2 8.85C2 8.29772 2.44772 7.85 3 7.85H6.15C7.08888 7.85 7.85 7.08888 7.85 6.15V3C7.85 2.44772 8.29772 2 8.85 2C9.40228 2 9.85 2.44772 9.85 3V6.15ZM22 8.85C22 9.40228 21.5523 9.85 21 9.85H17.85C15.8065 9.85 14.15 8.19345 14.15 6.15V3C14.15 2.44772 14.5977 2 15.15 2C15.7023 2 16.15 2.44772 16.15 3V6.15C16.15 7.08888 16.9111 7.85 17.85 7.85H21C21.5523 7.85 22 8.29772 22 8.85ZM8.85 22C8.29772 22 7.85 21.5523 7.85 21V17.85C7.85 16.9111 7.08888 16.15 6.15 16.15H3C2.44772 16.15 2 15.7023 2 15.15C2 14.5977 2.44772 14.15 3 14.15H6.15C8.19345 14.15 9.85 15.8065 9.85 17.85V21C9.85 21.5523 9.40228 22 8.85 22ZM15.15 22C14.5977 22 14.15 21.5523 14.15 21V17.85C14.15 15.8065 15.8065 14.15 17.85 14.15H21C21.5523 14.15 22 14.5977 22 15.15C22 15.7023 21.5523 16.15 21 16.15H17.85C16.9111 16.15 16.15 16.9111 16.15 17.85V21C16.15 21.5523 15.7023 22 15.15 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameMinimize);
export default __webpack_public_path__ + "static/media/frame-minimize.e2c3a2ebd247b39d0751e0ab9bfd399a.svg";
export { ForwardRef as ReactComponent };